export const state = () => ({
	customers: [],
	knoxCustomers: [],
	error: null,
	brands: [],
});

export const getters = {
	customers(state) {
		return state.customers;
	},
	knoxCustomers(state) {
		return state.knoxCustomers;
	},
	error(state) {
		return state.error;
	},
	brands(state) {
		return state.brands;
	},
};

export const mutations = {
	setCustomers(state, customers) {
		state.customers = customers;
	},
	setKnoxCustomers(state, knoxCustomers) {
		state.knoxCustomers = knoxCustomers;
	},
	setError(state, error) {
		state.error = error;
	},
	setBrands(state, brands) {
		state.brands = brands;
	},
};

export const actions = {
	async fetchAllCustomers({dispatch, commit, rootGetters}) {
		dispatch('clearError');
		try {
			const queryParams = getUserQueryParams(rootGetters);
			const customers = await this.$axios.$get('/api/customers', {params: queryParams});
			dispatch('setCustomers', customers);
		} catch (error) {
			let msg = 'Could not fetch customers';
			if (error) {
				msg = error.message;
			}
			commit('setError', msg);
		}
	},
	async fetchAllKnoxCustomers({dispatch, commit, rootGetters}) {
		dispatch('clearError');
		try {
			const queryParams = getUserQueryParams(rootGetters);
			const knoxCustomers = await this.$axios.$get('/api/knox-customers', {params: queryParams});
			dispatch('setKnoxCustomers', knoxCustomers);
		} catch (error) {
			let msg = 'Could not fetch customers';
			if (error) {
				msg = error.message;
			}
			commit('setError', msg);
		}
	},
	async getAllBrands({dispatch, rootGetters}) {
		try {
			const queryParams = getUserQueryParams(rootGetters);
			const brands = await this.$axios.$get('/api/brands', {params: queryParams});

			dispatch('setBrands', brands);
		} catch (error) {
			// console.log(error);
		}
	},
	setError({commit}, error) {
		commit('setError', error);
	},
	clearError({commit}) {
		commit('setError', null);
	},
	setBrands({commit}, brands) {
		commit('setBrands', brands);
	},
	setCustomers({commit}, customers) {
		commit('setCustomers', customers);
	},
	setKnoxCustomers({commit}, knoxCustomers) {
		commit('setKnoxCustomers', knoxCustomers);
	},
};


function getUserQueryParams(rootGetters) {
	const queryParams = {};
	const isConversaEmployee = rootGetters['user/isConversaEmployee'];
	if (isConversaEmployee) {
		queryParams['employee'] = isConversaEmployee;
	}

	const guid = rootGetters['user/guid'];
	if (guid) {
		queryParams['customer'] = guid;
	}

	return queryParams;
}

export const strict = false;
